import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import NoSSR from 'react-no-ssr';

import {
  useTheme,
  SPOTAHOME_THEME,
  ERASMUSU_THEME,
  LANDLORD_THEME,
  PARTNER_DEMO_THEME,
  PARTNER_RUFA_THEME,
  WGGESUCHT_THEME,
  ESTATE_TO_RENT_THEME
} from '../ThemeProvider';

const LOGOS = {
  [SPOTAHOME_THEME]: lazy(() => import('./logos/spotahome')),
  [LANDLORD_THEME]: lazy(() => import('./logos/spotahome')),
  [ERASMUSU_THEME]: lazy(() => import('./logos/erasmusu')),
  [PARTNER_DEMO_THEME]: lazy(() => import('./logos/partner_demo')),
  [PARTNER_RUFA_THEME]: lazy(() => import('./logos/partners/rufa')),
  [WGGESUCHT_THEME]: lazy(() => import('./logos/partners/wgg')),
  [ESTATE_TO_RENT_THEME]: lazy(() => import('./logos/estate_to_rent'))
};

const Logo = props => {
  const { theme } = useTheme();

  const LogoComponent = LOGOS[theme];

  return (
    <NoSSR>
      <Suspense fallback={'Loading...'}>
        <LogoComponent {...props} />
      </Suspense>
    </NoSSR>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'normal', 'large']),
  theme: PropTypes.oneOf(['dark', 'light'])
};

Logo.defaultProps = {
  className: '',
  size: 'normal',
  theme: 'dark'
};

export default Logo;
